// extracted by mini-css-extract-plugin
export var chip = "_3l-9";
export var chipLabel = "_3l-a";
export var close = "_3l-7";
export var closeIcon = "_3l-8";
export var error = "_3l-6";
export var infoTooltip = "_3l-2";
export var innerContainer = "_3l-1";
export var input = "_3l-b";
export var medium = "_3l-5";
export var outerContainer = "_3l-0";
export var small = "_3l-4";
export var xSmall = "_3l-3";